/* dp-collectie.js — eigen scripts van rol collectie (Dailyplay-audit 24-09-2026, Wim).
   Geladen met defer ná theme.js. Raakt alleen collectiepagina's; theme.js blijft ongewijzigd.
   1. Zwevende knop 'Filteren en sorteren' pas tonen als de bovenbalk uit beeld is (CUX-02, filters-023).
   2. Terugknop draait een filter/sortering terug (filters-005): pushState vóór de replaceState van het thema, popstate herlaadt de sectie.
   3. Teller op 'Toepassen' telt geen sortering mee (filters-006).
   4. Actieve pill in beeld schuiven (CUX-03).
   5. Sluitknop in de filterlade en de zwevende knop weg zolang de lade open is (filters-004).
   6. Prijsfilter: bovengrens naar boven afronden (34,95 blijft erin), komma als decimaal, omgekeerd bereik omdraaien (filters-024). */
(function () {
  if (window.dpCollectie) return;
  window.dpCollectie = true;

  var popping = false;

  function sectie() {
    return document.querySelector('.shopify-section--main-collection');
  }

  /* 2a. Vóór het thema replaceState doet: de huidige url als eigen stap bewaren. */
  document.addEventListener('facet:update', function () {
    if (popping) return;
    try { history.pushState({ dp: 1 }, '', location.href); } catch (e) { /* stil: geen historie is geen ramp */ }
  }, true);

  /* 2b. Terug/vooruit: de sectie opnieuw laden met de url uit de historie. */
  window.addEventListener('popstate', function () {
    var s = sectie();
    if (!s) return;
    var url = new URL(location.href);
    url.searchParams.set('section_id', s.id.replace('shopify-section-', ''));
    popping = true;
    document.dispatchEvent(new CustomEvent('facet:update', { bubbles: true, detail: { url: url } }));
    setTimeout(function () { popping = false; }, 0);
  });

  function zwevendeKnop() {
    var knop = document.querySelector('facet-floating-filter');
    var balk = document.querySelector('.collection__top-bar');
    if (!knop || !balk || knop.dataset.dpInit) return;
    knop.dataset.dpInit = '1';
    if (!('IntersectionObserver' in window)) { knop.classList.add('dp-zichtbaar'); return; }
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      var voorbij = !e.isIntersecting && e.boundingClientRect.top < 0;
      knop.classList.toggle('dp-zichtbaar', voorbij);
    }, { threshold: 0 }).observe(balk);
  }

  function ladeStand() {
    var lade = document.getElementById('facets-drawer');
    if (!lade || lade.dataset.dpInit) return;
    lade.dataset.dpInit = '1';
    var zet = function () { document.body.classList.toggle('dp-lade-open', lade.hasAttribute('open')); };
    new MutationObserver(zet).observe(lade, { attributes: true, attributeFilter: ['open'] });
    zet();
    var sluit = lade.querySelector('.dp-lade-sluit');
    if (sluit) sluit.addEventListener('click', function () { if (typeof lade.hide === 'function') lade.hide(); else lade.removeAttribute('open'); });
  }

  /* 3a. De teller van het thema zelf (FacetApplyButton._updateCount) telt de sortering mee; die methode vervangen we
     hier, zodat ook zijn eigen hertelling bij het openen van de lade klopt. theme.js blijft ongewijzigd. */
  function telVelden(form) {
    var n = 0;
    new FormData(form).forEach(function (waarde, naam) {
      if (naam === 'sort_by' || naam === 'page' || naam === 'section_id' || waarde === '') return;
      n++;
    });
    return n;
  }
  try {
    var ApplyKnop = window.customElements && customElements.get('facet-apply-button');
    if (ApplyKnop && ApplyKnop.prototype && !ApplyKnop.prototype.dpGeteld) {
      ApplyKnop.prototype.dpGeteld = true;
      ApplyKnop.prototype._updateCount = function () {
        if (!this.filterCountElement || !this.form) return;
        var n = telVelden(this.form);
        this.filterCountElement.innerText = n ? ' (' + n + ')' : '';
      };
    }
  } catch (e) { /* stil: dan blijft de teller van het thema staan */ }

  /* 6. Prijsvelden vóór de eigen afhandeling van het thema (capture-fase op document). */
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('input[name="filter.v.price.gte"], input[name="filter.v.price.lte"]')) return;
    var ruw = String(t.value || '').replace(',', '.').trim();
    if (ruw === '') return;
    var getal = parseFloat(ruw);
    if (isNaN(getal)) return;
    t.value = t.name === 'filter.v.price.lte' ? Math.ceil(getal) : Math.floor(getal);
    var form = t.form;
    if (!form) return;
    var laag = form.querySelector('input[name="filter.v.price.gte"]');
    var hoog = form.querySelector('input[name="filter.v.price.lte"]');
    if (laag && hoog && laag.value !== '' && hoog.value !== '' && parseFloat(laag.value) > parseFloat(hoog.value)) {
      var tijdelijk = laag.value; laag.value = hoog.value; hoog.value = tijdelijk;
    }
  }, true);

  function telToepassen() {
    var knop = document.querySelector('button[is="facet-apply-button"]');
    if (!knop || !knop.form) return;
    var n = telVelden(knop.form);
    var span = knop.filterCountElement || knop.querySelector('span:last-child');
    if (span) span.textContent = n ? ' (' + n + ')' : '';
  }

  function toepassenTeller() {
    var knop = document.querySelector('button[is="facet-apply-button"]');
    if (!knop || !knop.form || knop.dataset.dpInit) return;
    knop.dataset.dpInit = '1';
    knop.form.addEventListener('change', function () { setTimeout(telToepassen, 0); });
    setTimeout(telToepassen, 0);
  }

  function actievePill() {
    var actief = document.querySelector('.collection-link-item.active');
    var bak = actief && actief.closest('.collection-links');
    if (!actief || !bak || bak.dataset.dpInit) return;
    bak.dataset.dpInit = '1';
    if (bak.scrollWidth <= bak.clientWidth) return;
    var links = actief.offsetLeft - (bak.clientWidth - actief.offsetWidth) / 2;
    bak.scrollLeft = Math.max(0, links);
  }

  function init() {
    zwevendeKnop();
    ladeStand();
    toepassenTeller();
    actievePill();
  }

  function start() {
    init();
    var s = sectie();
    if (s) {
      var t;
      new MutationObserver(function () { clearTimeout(t); t = setTimeout(init, 60); }).observe(s, { childList: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

/* 7. spoed 24-09 (Damian): tellers in de filterlade bewegen live mee. Bij elke klik haalt dit de sectie op met de
   nieuwe filters (zonder de productlijst te vervangen) en zet het per optie het aantal en de uit-stand bij. */
(function () {
  var bezig = null;
  var ontsleutel = document.createElement('textarea');
  function schoon(k) { ontsleutel.innerHTML = k; return ontsleutel.value; }
  function lade() { var l = document.getElementById('facets-drawer'); return l && l.querySelector('form[is="facet-form"]'); }
  function ververs(form) {
    var sectie = form.getAttribute('section-id');
    var params = new URLSearchParams();
    new FormData(form).forEach(function (w, n) { if (n !== 'page' && n !== 'section_id' && w !== '') params.append(n, w); });
    params.set('section_id', sectie);
    if (bezig) bezig.abort();
    bezig = ('AbortController' in window) ? new AbortController() : null;
    fetch(location.pathname + '?' + params.toString(), bezig ? { signal: bezig.signal } : {})
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var s = doc.querySelector('script.dp-telling');
        if (!s) return;
        var ruw = JSON.parse(s.textContent), t = {};
        Object.keys(ruw).forEach(function (k) { t[schoon(k)] = ruw[k]; });
        form.querySelectorAll('input[type="checkbox"]').forEach(function (inp) {
          var k = inp.name + '|' + inp.value;
          if (!(k in t)) return;
          var n = t[k];
          var lab = form.querySelector('label[for="' + inp.id + '"]');
          if (lab) {
            var w = document.createTreeWalker(lab, NodeFilter.SHOW_TEXT), laatste = null, node;
            while ((node = w.nextNode())) { if (/\(\d+\)/.test(node.nodeValue)) laatste = node; }
            if (laatste) laatste.nodeValue = laatste.nodeValue.replace(/\(\d+\)\s*$/, '(' + n + ')');
          }
          var uit = n === 0 && !inp.checked;
          inp.disabled = uit;
          var bak = inp.closest('.checkbox-container');
          if (bak) bak.classList.toggle('dp-leeg', uit);
        });
      })
      .catch(function () { /* stil: bij een fout blijven de oude tellers staan */ });
  }
  document.addEventListener('change', function (e) {
    var form = lade();
    if (!form || !form.contains(e.target) || e.target.name === 'sort_by') return;
    ververs(form);
  });
})();
